// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import NavigationServicesPage from "../pages/NavigationServices/NavigationServices";
const __wvcRoutePaths = ["/NavigationServicesPage", "/navigation-services"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-me", "aboutmepage", "family-support", "familysupportpage", "faq", "faqpage", "free-consultation", "freeconsultationpage", "home", "homepage", "navigation-services", "navigationservicespage", "patient-booking", "patientbookingpage", "post", "resources", "resourcespage", "services", "servicespage", "start-with-clarity", "startwithclaritypage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<NavigationServicesPage />} />
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<NavigationServicesPage />} />
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
